import Rails from "@rails/ujs";

if (!(window as any).Rails) {
  Rails.start();
  (window as any).Rails = Rails;
}
